// Pantalla de EMPAREJAMIENTO (/signage/pair — pública). La caja Android se
// configura para abrir SIEMPRE esta URL. Muestra un código de 6 dígitos; el
// admin lo escribe en Signage → Pantallas → "Vincular pantalla". Al vincular,
// la caja recibe su token real, lo guarda y salta al reproductor. En el próximo
// arranque, si ya está vinculada, va directo al reproductor.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, MonitorSmartphone } from 'lucide-react';
import { apiClient } from '@/lib/api/client';

const KEY = 'sig_token';

export function SignagePair() {
  const navigate = useNavigate();
  const [codigo, setCodigo] = useState<string | null>(null);
  const ttRef = useRef<string>('');

  useEffect(() => {
    const guardado = localStorage.getItem(KEY);
    if (guardado) { navigate(`/signage/tv/${guardado}`, { replace: true }); return; }

    let alive = true; let poll: ReturnType<typeof setInterval> | null = null;

    const iniciar = async () => {
      try {
        const r = (await apiClient.post('/rpc/sig_emparejar_iniciar', { _info: { ua: navigator.userAgent } })).data as { codigo: string; token_temporal: string };
        if (!alive) return;
        ttRef.current = r.token_temporal; setCodigo(r.codigo);
      } catch { if (alive) setTimeout(iniciar, 5000); }
    };

    const sondear = async () => {
      if (!ttRef.current) return;
      try {
        const s = (await apiClient.post('/rpc/sig_emparejar_estado', { _token_temporal: ttRef.current })).data as { estado: string; token: string | null };
        if (!alive) return;
        if (s.estado === 'vinculada' && s.token) {
          localStorage.setItem(KEY, s.token);
          navigate(`/signage/tv/${s.token}`, { replace: true });
        } else if (s.estado === 'expirada') {
          setCodigo(null); ttRef.current = ''; void iniciar();
        }
      } catch { /* sin red: reintenta al próximo tick */ }
    };

    void iniciar();
    poll = setInterval(sondear, 3000);
    return () => { alive = false; if (poll) clearInterval(poll); };
  }, [navigate]);

  return (
    <div style={{ width: '100vw', height: '100vh' }} className="flex flex-col items-center justify-center gap-8 bg-slate-950 text-white p-8 text-center">
      <MonitorSmartphone className="w-16 h-16 text-cyan-400" />
      <div>
        <div className="text-lg text-white/70">Para activar esta pantalla, ingresa este código en</div>
        <div className="text-lg text-white/70 mb-6">Signage → Pantallas → <span className="text-cyan-300">Vincular pantalla</span></div>
        {codigo ? (
          <div className="font-mono font-bold tracking-[0.3em] text-white" style={{ fontSize: '18vw', lineHeight: 1 }}>{codigo}</div>
        ) : (
          <Loader2 className="w-10 h-10 animate-spin mx-auto text-white/60" />
        )}
      </div>
      <div className="text-sm text-white/40">El código expira en 15 minutos · esta pantalla se activará sola al vincularla</div>
    </div>
  );
}
